export const extractErrorMessage = (error, fallback = 'An unexpected error occurred.') => {
  if (!error) return fallback;

  if (typeof error === 'string') return error;

  if (error.response?.data) {
    const data = error.response.data;

    if (data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
      const firstField = Object.keys(data.errors)[0];
      const firstError = data.errors[firstField];
      if (Array.isArray(firstError)) return firstError[0];
      if (typeof firstError === 'string') return firstError;
    }

    if (data.message) return data.message;

    if (data.error) return data.error;
  }

  if (error.message) return error.message;

  return fallback;
};
